import React, { useState, useEffect } from 'react';
import { GameProvider } from './context/GameContext';
import { MainView } from './components';
import MainMenu from './components/MainMenu';
import './styles/index.css';
import './styles/research-queue.css';

function App() {
  const [gameStarted, setGameStarted] = useState(false);
  const [hasSave, setHasSave] = useState(false);

  useEffect(() => {
    // Check if there's an existing save
    const save = localStorage.getItem('medievalKingdomSave');
    setHasSave(!!save);
  }, []);

  const handleNewGame = () => {
    localStorage.removeItem('medievalKingdomSave');
    setGameStarted(true);
  };

  const handleContinue = () => {
    setGameStarted(true);
  };

  if (!gameStarted) {
    return (
      <MainMenu 
        onNewGame={handleNewGame}
        onContinue={handleContinue}
        hasSave={hasSave}
      />
    );
  }

  return (
    <GameProvider>
      <MainView />
    </GameProvider>
  );
}

export default App;